<template>
  <div>
     <ContainerTemplate v-bind="properties"></ContainerTemplate>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import  ContainerTemplate  from "./ContainerTemplate"

export default {
  name: 'EMCoreTemplate',
  components: {
    ContainerTemplate
  },
  props:{
    identity:{
      type:String,
      required: true,
    },
    entity:{
      type:String,
      required: true,
    },
    category:{
      type:String,
      required:true,
    }
  },
  data() {
    return {
      properties: {
        label: this.$t("adm.contents.EntityManagement.title") + ' (' + this.$t("adm.contents.EntityManagement."+this.category+".name") + ') - ' + this.$t("adm.contents.EntityManagement."+this.category+"."+this.identity+".title"),
        createBtn: { text:this.$t("adm.contents.EntityManagement.createBtn")+' '+ this.$t("adm.contents.EntityManagement."+this.category+"."+this.identity+".title"), variant: 'success' },
        vuex: this.$store.state.EntityManagement.dataList,
      },
   }
  },
  created(){
    // console.log(this.category);
        this.$store.commit({ type: 'EntityManagement/setCategory', category: this.category });
      this.$store.commit({ type: 'EntityManagement/setIdentity', identity: this.identity });
      this.$store.commit({ type: 'EntityManagement/setEntity', entity: this.entity });

      if(this.identity == 'product'){
        this.properties.label = this.$t('adm.product.list.title');
      }
  },
  computed:{

  },
  mounted(){
  }

}

</script>



// WEBPACK FOOTER //
// src/Adm/EntityManagement/components/EMCoreTemplate.vue